"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BuySellMakeTransactionComponent = _interopRequireDefault(require("./BuySellMakeTransactionComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _BuySellMakeTransactionComponent["default"];